import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';
import React, { useContext } from 'react';
import { ModalType } from '@models/pages';
import { GlobalContext } from '../GlobalContext';

type Props = {
  globalCmsButtons: any,
  lang: string,
}

function ShareButton({ globalCmsButtons, lang }: Props) {
  const globalContext = useContext(GlobalContext);
  const linkDetails = globalCmsButtons.Share[lang];

  const handleOpenModal = () => {
    if (globalContext) {
      const { setShowModal } = globalContext;
      setShowModal(ModalType.SocialShare);
    }
  };

  return (
    <button
      key={linkDetails.id}
      type="button"
      className="flex items-center mr-3 font-semibold tracking-wider text-center uppercase md:mr-8 text-chdGreen-light hover:text-chdGreen-hover"
      onClick={handleOpenModal}
    >
      <ArrowTopRightOnSquareIcon className="mr-1 w-[1rem]" fill="white" />
      {linkDetails.title}
    </button>
  );
}

export default ShareButton;
